/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stage } from './Stage';
import {
    StageFromJSON,
    StageFromJSONTyped,
    StageToJSON,
    StageToJSONTyped,
} from './Stage';

/**
 * 
 * @export
 * @interface PaginatedStageList
 */
export interface PaginatedStageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedStageList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStageList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStageList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Stage>}
     * @memberof PaginatedStageList
     */
    results: Array<Stage>;
}

/**
 * Check if a given object implements the PaginatedStageList interface.
 */
export function instanceOfPaginatedStageList(value: object): value is PaginatedStageList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedStageListFromJSON(json: any): PaginatedStageList {
    return PaginatedStageListFromJSONTyped(json, false);
}

export function PaginatedStageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedStageList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(StageFromJSON)),
    };
}

  export function PaginatedStageListToJSON(json: any): PaginatedStageList {
      return PaginatedStageListToJSONTyped(json, false);
  }

  export function PaginatedStageListToJSONTyped(value?: PaginatedStageList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(StageToJSON)),
    };
}

